import { createBrowserRouter, Navigate } from "react-router-dom";
import PaymentSuccessPage from "./common/PaymentSuccessPage";

const paymentSuccessRoutes = createBrowserRouter([
  {
    path: 'transaction',
    element: undefined,
    children: [
      { path: 'success', element: <PaymentSuccessPage />, index: true },
    ]
  },
  {
    path: '*',
    element: <Navigate to='/transaction/success' />
  }
]);

export default paymentSuccessRoutes;